import JsComponent from '../jsComponent/jsComponent.js';
import pigeon from '../../utilities/js/pigeon/pigeon.js';
import jsGlobalConfig from '../../globals/jsGlobalConfig';
import pageStore from '@/bps/stores/page/PageStore';
import pageService from '@/bps/services/pageService/PageService';
import {watch} from 'vue';

class UserShortcut extends JsComponent {
  constructor(mainElement, name = 'user-shortcut') {
    super(mainElement, name);
    this.createClassNames(
      '__notification-badge',
      '__notification-badge--active',
      '__notification-badge--update',
      '--has-badge'
    );

    this.type = this.mainElement.dataset.type;
    this.notificationBadge = this.mainElement.querySelector(`.${this.classNames.notificationBadge}`);

    if (this.type === 'cart') {
      this.createCartShortcut();
      this.addEvents();
      pigeon.subscribe('productaddedToCart:updateCounter', this.updateCounter.bind(this));
      pigeon.subscribe('productRemovedFromCart:updateCounter', this.updateCounter.bind(this));
    } else if (this.type === 'wishlist') {
      this.createWishlistShortcut();
      pigeon.subscribe('productaddedToWishlist:updateCounter', this.updateWishlistCounter.bind(this));
    } else if (this.type === 'assistant') {
      this.addAssistantEvents();
    } else {
      if (this.notificationBadge && this.notificationBadge.attributes['data-initial-count']) {
        this.setInitialBadgeCount(this.notificationBadge.attributes['data-initial-count'].value);
      }
    }

    if (pageService && pageStore && this.type === 'cart') {
      watch(() => pageStore.activeVoucherCode, (newValue) => {
        this.setPromotionBadge(newValue && newValue.length > 0);
      });
    }

    if (pageStore && this.type === 'assistant') {
      watch(() => pageStore.chatBotData.activeAssistantChatId, (activeAssistantChatId) => {
        this.setAssistantState(!!activeAssistantChatId);
      });

      this.setAssistantState(!!pageStore.chatBotData.activeAssistantChatId);
    }
  }

  addEvents() {
    this.mainElement.addEventListener('mouseover', this.handleCartClick.bind(this));
    this.mainElement.addEventListener('mouseout', this.cancelCartLayer.bind(this));
    this.mainElement.addEventListener('touchend', this.handleCartClick.bind(this));
  }

  addAssistantEvents() {
    this.mainElement.addEventListener('click', this.handleAssistantClick.bind(this));
  }

  handleAssistantClick(event) {
    event.preventDefault();
    pigeon.publish('chatBotPanel:open', {});
  }

  handleCartClick(event) {
    const isSmallLayer = document.querySelector('.add-to-cart-layer--small') !== null;
    if (isSmallLayer || jsGlobalConfig().getAbVariants().newCheckout) {
      return true;
    }

    const isLayerOpen = document.querySelector('.add-to-cart-layer .add-to-cart-layer__header') != null;
    if (!isLayerOpen && this.notificationBadge.dataset.initialCount > 0) {
      pigeon.publish('userShortcut:openCartLayer');
      event.preventDefault();
      return false;
    }
  }

  cancelCartLayer() {
    clearTimeout(this.timeoutId);
  }

  updateCounter(data) {
    if (!data && data !== 0) {
      return;
    }
    this.setInitialBadgeCount(data);

    this.notificationBadge.classList.remove(this.classNames.notificationBadgeUpdate);
    setTimeout(() => {
      this.notificationBadge.classList.add(this.classNames.notificationBadgeUpdate);
    }, 10);
  }

  updateWishlistCounter(data) {
    if (!data) {
      return;
    }
    this.createWishlistShortcut(data);

    this.mainElement.classList.remove(this.classNames.notificationBadgeUpdate);
    setTimeout(() => {
      this.mainElement.classList.add(this.classNames.notificationBadgeUpdate)
    }, 10);
  }

  createCartShortcut() {
    const count = this.notificationBadge.attributes['data-initial-count'] ? this.notificationBadge.attributes['data-initial-count'].value : 0;
    this.setInitialBadgeCount(count);
  }

  createWishlistShortcut(data) {
    this.notificationBadge.textContent = data ? data : this.notificationBadge.dataset.initialCount;
    if (this.notificationBadge.dataset.initialCount > 0 || data > 0) {
      this.mainElement.classList.add(this.classNames.notificationBadgeActive);
      this.mainElement.classList.add(this.classNames.hasBadge);
    }
  }

  setInitialBadgeCount(data) {
    const count = parseInt(data);
    if (count > 0) {
      this.notificationBadge.textContent = count > 99 ? '99+' : count;
    } else {
      this.notificationBadge.textContent = '';
    }
    this.notificationBadge.setAttribute('data-count', count);

    if (count > 0) {
      this.notificationBadge.classList.add(this.classNames.notificationBadgeActive);
      this.mainElement.classList.add(this.classNames.hasBadge);
    } else {
      this.notificationBadge.classList.remove(this.classNames.notificationBadgeActive);
      this.mainElement.classList.remove(this.classNames.hasBadge);
    }
  }

  setPromotionBadge(setActive) {
    const badge = document.querySelector('.promotion-badge');
    if (setActive) {
      badge.classList.add('promotion-badge--active');
    } else {
      badge.classList.remove('promotion-badge--active');
    }
  }

  setAssistantState(active) {
    const button = this.mainElement.querySelector('.user-shortcut__link');
    if (active) {
      button.classList.add('user-shortcut__link--assistant-active');
    } else {
      button.classList.remove('user-shortcut__link--assistant-active');
    }
  }
}

export default UserShortcut;
